import { GetAllHealthQuoteParams } from '@apis/HealthQuoteApi';
import { getRoute } from '@utils/route';

export type HealthQuoteResultPageParams = GetAllHealthQuoteParams;

export const HEALTH_QUOTE_RESULT_PAGE_URL = '/health-insurance-quote-results';

export const routeHealthQuoteResultPage = (searchParams: HealthQuoteResultPageParams) => getRoute(HEALTH_QUOTE_RESULT_PAGE_URL, { searchParams });
